import { useEffect, useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { version } from '../../version';

const Portal = (props: { children: ReactNode; selector?: string }) => {
  props = {
    selector: '__PARTICLE_CONNECTKIT__',
    ...props,
  };

  const { selector, children } = props;

  const ref = useRef<Element | null>(null);

  const [mounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    const selectorPrefixed = '#' + selector?.replace(/^#/, '');
    ref.current = document.querySelector(selectorPrefixed);

    if (!ref.current) {
      const div = document.createElement('div');
      div.setAttribute('id', selector as string);
      div.setAttribute('data-connectkit-version', `${version}`);
      document.body.appendChild(div);
      ref.current = div;
    }

    setMounted(true);
  }, [selector]);

  if (!ref.current) return null;
  return mounted ? createPortal(children, ref.current) : null;
};

export default Portal;
